import {defaultNamespace, i18n} from '@twigsby/frontend-framework';
import EN from './Locales/en/translation.json';
import JP from './Locales/jp/translation.json';

i18n.addResourceBundle('en', defaultNamespace, EN);
i18n.addResourceBundle('jp', defaultNamespace, JP);
